// @flow
import { getUserData, isBidderLoaded } from './user';
import { createSelector } from 'reselect';
import type { GlobalState } from '../rootReducer';

/* Action Types */
export const LOCATION_FAIL = 'la/LOCATION/FAIL';
export const LOCATION_REQUEST = 'la/LOCATION/REQUEST';
export const LOCATION_SUCCESS = 'la/LOCATION/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    location: '',
    submitted: false,
    success: false,
    timestamp: null,
};

export type State = {|
    ...typeof DEFAULT_STATE,
    errorMessage: ?string,
    timestamp: ?string, // might not be a string
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOCATION_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: null,
                submitted: true,
                success: false,
            };
        case LOCATION_SUCCESS:
            return {
                ...state,
                location: action.payload.coordinates || action.payload.zipcode,
                submitted: false,
                success: true,
                timestamp: action.payload.timestamp,
            };
        case LOCATION_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

const stateSelector = (state: GlobalState) => state.location;

export const getLocation = createSelector(stateSelector, state => state.location);

export const fetchLocation = () => async (dispatch: Function, getState: Function) => {
    try {
        dispatch({
            type: LOCATION_REQUEST,
        });

        const state = getState();
        if (isBidderLoaded(state)) {
            const { zip: zipcode } = getUserData(state);
            dispatch({
                payload: {
                    timestamp: Date.now(),
                    zipcode,
                },
                type: LOCATION_SUCCESS,
            });
        } else {
            // const geolocation = navigator.geolocation;
            // geolocation.getCurrentPosition(({ coords: coordinates, timestamp }) => {
            //     dispatch({
            //         payload: {
            //             coordinates,
            //             timestamp,
            //         },
            //         type: LOCATION_SUCCESS,
            //     });
            // });
        }
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: LOCATION_FAIL,
        });
    }
};
